import { render, staticRenderFns } from "./ColumnImpersonate.vue?vue&type=template&id=5441491d"
import script from "./ColumnImpersonate.vue?vue&type=script&lang=js"
export * from "./ColumnImpersonate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5441491d')) {
      api.createRecord('5441491d', component.options)
    } else {
      api.reload('5441491d', component.options)
    }
    module.hot.accept("./ColumnImpersonate.vue?vue&type=template&id=5441491d", function () {
      api.rerender('5441491d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnImpersonate.vue"
export default component.exports